export default "__VITE_ASSET__Lq37TZkG__"